export const convertImgUrl = (imgUrl) => {
    if(!imgUrl) return "";
    const url = imgUrl.replace(/^[a-z]{4,5}\:\/{2}[a-z]{1,}\:[0-9]{1,4}.(.*)/, "$1");
    const finalUrl = window.location.origin + "/" + url;
    return finalUrl;
}